export const broadcastData = {
  talk1: {
    title: "Metro News Update",
    type: "broadcast",
    versions: {
      basic: {
        script: `Good morning, listeners. This is Metro News Update, <mark>bringing you the latest updates on local events</mark>, weather, and transportation.
        <mark>First, due to a water main repair project, Maple Avenue will be closed to traffic starting Wednesday</mark>. The road is expected to reopen by next Monday. Drivers are encouraged to take alternate routes to avoid delays.
        Next, meteorologists predict a sudden drop in temperature this evening, with overnight lows reaching minus five degrees Celsius. <mark>Residents are advised to take precautions when driving, as roads may become icy</mark>.
        Finally, for those looking for weekend activities, the Grand City Food Festival will take place this Saturday at Riverfront Park. The event will feature over 50 food vendors, live music, and cooking demonstrations. Tickets are available online, and children under 12 can enter for free.
        That's all for today's update. Stay safe and have a great day.`,
        translation: `안녕하세요 청취자 여러분. 지역 행사, 날씨, 교통 상황에 대한 최신 소식을 전해드리는 메트로 뉴스 업데이트입니다.
        먼저, 수도관 보수 공사로 인해 수요일부터 메이플 애비뉴의 교통이 통제됩니다. 도로는 다음 주 월요일까지 재개통될 예정입니다. 운전자들은 지연을 피하기 위해 우회도로를 이용하시기 바랍니다.
        다음으로, 기상학자들은 오늘 저녁 기온이 급격히 떨어져 밤사이 영하 5도까지 내려갈 것으로 예측합니다. 주민들은 따뜻하게 옷을 입고, 도로가 얼 수 있으니 운전 시 주의하시기 바랍니다.
        마지막으로, 주말 활동을 찾으시는 분들을 위해 이번 토요일 리버프런트 파크에서 그랜드 시티 푸드 페스티벌이 열립니다. 50개 이상의 음식 판매점, 라이브 음악, 요리 시연이 진행됩니다. 티켓은 온라인에서 구매 가능하며, 12세 미만 어린이는 무료입니다.
        오늘의 업데이트는 여기까지입니다. 안전하고 좋은 하루 보내세요.`,
        audioUrl: {
          us: "audios/part4/broadcast/us/us1.mp3",
          uk: "audios/part4/broadcast/uk/uk1.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main purpose of the broadcast?",
        questionKr: "이 방송의 주요 목적은 무엇입니까?",
        options: {
          A: "To promote the <mark>Food Festival</mark>",
          B: "To provide <mark>local news updates</mark>",
          C: "To warn about <mark>road conditions</mark>",
          D: "To introduce a new <mark>business</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 푸드 페스티벌을 홍보하기 위해
B: 지역 뉴스 업데이트를 제공하기 위해
C: 도로 상황에 대해 경고하기 위해
D: 새로운 사업체를 소개하기 위해

정답 B: 스크립트의 "This is Metro News Update, bringing you the latest updates on local events, weather, and transportation"에서 지역 뉴스 업데이트를 제공하는 것이 주요 목적임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What will happen on Wednesday?",
        questionKr: "수요일에 무슨 일이 일어날 예정입니까?",
        options: {
          A: "A <mark>storm</mark> will cause delays",
          B: "A <mark>festival</mark> will begin",
          C: "A <mark>road</mark> will be closed for <mark>repairs</mark>",
          D: "A new <mark>restaurant</mark> will open",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 폭풍으로 인한 지연이 발생할 것이다
B: 축제가 시작될 것이다
C: 도로가 보수 공사로 폐쇄될 것이다
D: 새로운 식당이 개업할 것이다

정답 C: 스크립트의 "due to a water main repair project, Maple Avenue will be closed to traffic starting Wednesday"에서 수요일부터 도로가 보수 공사로 폐쇄될 것임을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What does the speaker suggest residents do?",
        questionKr: "연사는 주민들에게 무엇을 제안합니까?",
        options: {
          A: "Drive carefully due to <mark>icy roads</mark>",
          B: "Purchase <mark>tickets</mark> early for the <mark>festival</mark>",
          C: "Avoid <mark>crowded areas</mark>",
          D: "Check the <mark>city's website</mark> for updates",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 도로가 얼 수 있으니 조심히 운전하라
B: 축제 티켓을 일찍 구매하라
C: 혼잡한 지역을 피하라
D: 업데이트를 위해 시 웹사이트를 확인하라

정답 A: 스크립트의 "Residents are advised to take precautions when driving, as roads may become icy"에서 도로가 얼 수 있으니 운전 시 주의하라고 제안하고 있음을 알 수 있습니다.`,
      },
    ],
  },

  talk2: {
    title: "City News Hour",
    type: "broadcast",
    versions: {
      basic: {
        script: `Good morning, listeners. This is City News Hour, bringing you the <mark>latest updates from around town</mark>.
        First, the city council has just announced that a <mark>new public library</mark> will be built downtown. The facility will feature modern study rooms, digital archives, and a café. <mark>Construction is set to begin next month and is expected to be completed within a year</mark>.
        <mark>Next, a major renovation project is underway at Greenfield Park</mark>. The city is adding a new playground, additional picnic areas, and an outdoor stage for performances. The park will remain open, but certain areas will be temporarily closed during the renovation.
        Finally, the Spring Community Market is returning this Saturday at the central square. More than 100 local vendors will sell fresh produce, handmade crafts, and specialty foods. The market will run from 9 a.m. to 5 p.m., and admission is free.
        That's all for today's update. Stay tuned for more news.`,
        translation: `안녕하세요 청취자 여러분. 지역의 최신 소식을 전해드리는 시티 뉴스 아워입니다.
        먼저, 시의회는 시내에 새로운 공공 도서관을 건설할 것이라고 발표했습니다. 이 시설은 현대적인 학습실, 디지털 자료실, 카페를 갖출 예정입니다. 공사는 다음 달에 시작되어 1년 내에 완공될 예정입니다.
        다음으로, 그린필드 공원에서 대규모 개보수 공사가 진행 중입니다. 시에서는 새로운 놀이터, 추가 피크닉 구역, 공연을 위한 야외 무대를 설치하고 있습니다. 공원은 계속 개방되지만, 공사 기간 동안 일부 구역은 임시 폐쇄됩니다.
        마지막으로, 봄 커뮤니티 마켓이 이번 토요일 중앙 광장에서 다시 열립니다. 100개 이상의 지역 판매점에서 신선한 농산물, 수공예품, 특산 식품을 판매할 예정입니다. 마켓은 오전 9시부터 오후 5시까지 운영되며, 입장은 무료입니다.
        오늘의 뉴스는 여기까지입니다. 다음 소식도 기대해 주세요.`,
        audioUrl: {
          us: "audios/part4/broadcast/us/us2.mp3",
          uk: "audios/part4/broadcast/uk/uk2.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the broadcast mainly about?",
        questionKr: "이 방송은 주로 무엇에 관한 것입니까?",
        options: {
          A: "A city council <mark>meeting</mark>",
          B: "The local news <mark>updates</mark>",
          C: "The weather <mark>forecasts</mark>",
          D: "A <mark>real estate</mark> project",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 시의회 회의
B: 지역 뉴스 업데이트
C: 일기 예보
D: 부동산 프로젝트

정답 B: 스크립트의 "This is City News Hour, bringing you the latest updates from around town"에서 지역 뉴스 업데이트를 전달하는 방송임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What is expected to happen <mark>next month</mark>?",
        questionKr: "다음 달에 무슨 일이 일어날 예정입니까?",
        options: {
          A: "A <mark>public library</mark> will begin <mark>construction</mark>",
          B: "A <mark>farmers' market</mark> will open",
          C: "A new <mark>law</mark> will take effect",
          D: "A <mark>museum</mark> will be renovated",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 공공 도서관 건설이 시작될 것이다
B: 농산물 시장이 개장할 것이다
C: 새로운 법이 시행될 것이다
D: 박물관이 개보수될 것이다

정답 A: 스크립트의 "a new public library will be built downtown... Construction is set to begin next month"에서 다음 달에 공공 도서관 건설이 시작될 것임을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "What does the speaker say about <mark>Greenfield Park</mark>?",
        questionKr: "연사는 그린필드 공원에 대해 무엇이라고 말합니까?",
        options: {
          A: "It will host a <mark>concert</mark> this weekend",
          B: "It is undergoing <mark>renovations</mark>",
          C: "It will be <mark>closed</mark> for the next six months",
          D: "It will be expanded with a new <mark>walking trail</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 이번 주말에 콘서트가 열릴 것이다
B: 개보수 공사가 진행 중이다
C: 앞으로 6개월 동안 폐쇄될 것이다
D: 새로운 산책로가 추가되어 확장될 것이다

정답 B: 스크립트의 "a major renovation project is underway at Greenfield Park"에서 그린필드 공원에서 대규모 개보수 공사가 진행 중임을 알 수 있습니다.`,
      },
    ],
  },

  talk3: {
    title: "Community News Update",
    type: "broadcast",
    versions: {
      basic: {
        script: `Good afternoon, listeners. This is Community News Update, <mark>bringing you the latest developments in our city</mark>.
        <mark>First, a new community center is set to open next month</mark> in the Westwood district. The facility will offer free educational programs, fitness classes, and a public meeting space. Local officials hope it will become a hub for residents of all ages.
        Next, the city government has announced a new recycling initiative. Starting next Monday, households will be required to separate food waste from regular trash. Free compost bins will be distributed to residents at designated pickup locations.
        Finally, the <mark>Annual Spring Parade</mark> is scheduled for this Sunday. The event will feature marching bands, colorful floats, and performances from local artists. <mark>The parade route will go through Main Street, so expect road closures from 8 a.m. to noon</mark>.
        That's all for today's update. Stay informed and enjoy your day.`,
        translation: `안녕하세요 청취자 여러분. 우리 도시의 최신 소식을 전해드리는 커뮤니티 뉴스 업데이트입니다.
        먼저, 웨스트우드 지역에 다음 달 새로운 커뮤니티 센터가 문을 엽니다. 이 시설은 무료 교육 프로그램, 피트니스 수업, 공공 모임 공간을 제공할 예정입니다. 지역 관계자들은 이곳이 모든 연령대 주민들의 중심지가 되기를 희망합니다.
        다음으로, 시 정부가 새로운 재활용 정책을 발표했습니다. 다음 주 월요일부터 각 가정은 음식물 쓰레기를 일반 쓰레기와 분리해야 합니다. 무료 퇴비통이 지정된 장소에서 주민들에게 배포될 예정입니다.
        마지막으로, 연례 봄 퍼레이드가 이번 일요일로 예정되어 있습니다. 행사에는 마칭 밴드, 화려한 장식차량, 지역 예술가들의 공연이 펼쳐집니다. 퍼레이드가 메인 스트리트를 지나갈 예정이므로, 오전 8시부터 정오까지 도로가 통제됩니다.
        오늘의 업데이트는 여기까지입니다. 좋은 하루 보내세요.`,
        audioUrl: {
          us: "audios/part4/broadcast/us/us3.mp3",
          uk: "audios/part4/broadcast/uk/uk3.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main purpose of the broadcast?",
        questionKr: "이 방송의 주요 목적은 무엇입니까?",
        options: {
          A: "To announce new <mark>business</mark> openings",
          B: "To provide updates on <mark>local events</mark>",
          C: "To discuss <mark>environmental concerns</mark>",
          D: "To promote a <mark>festival</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 새로운 사업체 개업을 발표하기 위해
B: 지역 행사에 대한 업데이트를 제공하기 위해
C: 환경 문제를 논의하기 위해
D: 축제를 홍보하기 위해

정답 B: 스크립트의 "This is Community News Update, bringing you the latest developments in our city"에서 지역 소식과 행사에 대한 업데이트를 제공하는 것이 주요 목적임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What will happen <mark>next month</mark>?",
        questionKr: "다음 달에 무슨 일이 일어날 예정입니까?",
        options: {
          A: "A <mark>community center</mark> will open",
          B: "A new <mark>waste management law</mark> will take effect",
          C: "A <mark>park</mark> will be renovated",
          D: "A <mark>public library</mark> will hold an event",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 커뮤니티 센터가 문을 열 것이다
B: 새로운 폐기물 관리법이 시행될 것이다
C: 공원이 개보수될 것이다
D: 공공 도서관이 행사를 개최할 것이다

정답 A: 스크립트의 "a new community center is set to open next month in the Westwood district"에서 다음 달에 새 커뮤니티 센터가 개장할 것임을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "What does the speaker say about the <mark>Spring Parade</mark>?",
        questionKr: "연사는 봄 퍼레이드에 대해 무엇이라고 말합니까?",
        options: {
          A: "It will be postponed due to <mark>weather</mark>",
          B: "It will take place in the <mark>city square</mark>",
          C: "It will cause some <mark>road closures</mark>",
          D: "It will feature <mark>international performances</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 날씨로 인해 연기될 것이다
B: 시청 광장에서 열릴 것이다
C: 일부 도로가 통제될 것이다
D: 국제 공연이 펼쳐질 것이다

정답 C: 스크립트의 "The parade route will go through Main Street, so expect road closures from 8 a.m. to noon"에서 퍼레이드로 인해 도로가 통제될 것임을 알 수 있습니다.`,
      },
    ],
  },

  talk4: {
    title: "Morning Weather Update",
    type: "broadcast",
    versions: {
      basic: {
        script: `Good morning, listeners. This is Morning Weather Update, <mark>bringing you today's forecast</mark>.
        The day will start off cloudy, but by late morning, heavy rain will move into the region. Rainfall amounts could reach up to 50 millimeters, and <mark>isolated thunderstorms are possible in the afternoon. Along with the rain, strong winds are expected throughout the day</mark>. Wind speeds may reach up to 70 kilometers per hour, making outdoor activities difficult.
        By late tonight, the storm will gradually weaken, and skies will begin to clear. However, temperatures will drop significantly overnight, reaching a low of 5 degrees Celsius. <mark>Residents should dress warmly if heading out early tomorrow morning</mark>.
        That's all for today's forecast. Stay safe, and tune in for further updates.`,
        translation: `안녕하세요 청취자 여러분. 오늘의 일기 예보를 전해드리는 모닝 웨더 업데이트입니다.
        오늘은 흐린 날씨로 시작되지만, 늦은 오전에는 많은 비가 이 지역으로 이동해 올 것입니다. 강수량은 최대 50밀리미터에 달할 수 있으며, 오후에는 국지성 뇌우가 발생할 가능성이 있습니다. 운전자들은 도로가 미끄러워질 수 있으니 특별히 주의하시기 바랍니다.
        비와 함께 하루 종일 강한 바람이 예상됩니다. 풍속은 시속 70킬로미터까지 도달할 수 있어 야외 활동이 어려울 것으로 예상됩니다.
        오늘 늦은 밤에는 폭풍이 점차 약화되고 하늘이 맑아지기 시작할 것입니다. 하지만 기온은 밤사이 크게 떨어져 최저 기온이 섭씨 5도까지 내려갈 것입니다. 내일 아침 일찍 외출하시는 분들은 따뜻하게 입으시기 바랍니다.
        이상 오늘의 일기 예보였습니다. 안전하시기 바라며, 추가 업데이트는 계속 청취해 주시기 바랍니다.`,
        audioUrl: {
          us: "audios/part4/broadcast/us/us4.mp3",
          uk: "audios/part4/broadcast/uk/uk4.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main topic of the broadcast?",
        questionKr: "이 방송의 주요 주제는 무엇입니까?",
        options: {
          A: "A report on <mark>yesterday's</mark> weather",
          B: "A <mark>forecast</mark> for severe weather conditions",
          C: "A <mark>traffic</mark> update for commuters",
          D: "A <mark>new</mark> weather <mark>tracking system</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 어제 날씨에 대한 보고
B: 악천후 예보
C: 통근자들을 위한 교통 업데이트
D: 새로운 날씨 추적 시스템

정답 B: 스크립트의 "This is Morning Weather Update, bringing you today's forecast"와 함께 폭우, 뇌우, 강풍 등 악천후 상황을 예보하고 있음을 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          "What does the speaker say about the <mark>afternoon</mark> weather?",
        questionKr: "연사는 오후 날씨에 대해 무엇이라고 말합니까?",
        options: {
          A: "Skies will be <mark>clear</mark>",
          B: "There will be <mark>strong winds</mark> and <mark>thunderstorms</mark>",
          C: "It will be <mark>sunny</mark> with high temperatures",
          D: "A <mark>snowstorm</mark> is expected",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 하늘이 맑을 것이다
B: 강한 바람과 뇌우가 있을 것이다
C: 기온이 높고 맑을 것이다
D: 눈보라가 예상된다

정답 B: 스크립트의 "isolated thunderstorms are possible in the afternoon. Along with the rain, strong winds are expected throughout the day"에서 오후에 뇌우와 강풍이 예상됨을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What recommendation does the speaker give?",
        questionKr: "연사는 어떤 조언을 합니까?",
        options: {
          A: "Wear warm clothing <mark>tomorrow morning</mark>",
          B: "Avoid walking outside due to <mark>snow</mark>",
          C: "Carry an <mark>umbrella</mark> to stay dry in the morning",
          D: "Leave work <mark>early</mark> to avoid <mark>traffic</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 내일 아침에 따뜻한 옷을 입으라
B: 눈 때문에 외출을 피하라
C: 아침에 비를 피하기 위해 우산을 가져가라
D: 교통 체증을 피하기 위해 일찍 퇴근하라

정답 A: 스크립트의 "Residents should dress warmly if heading out early tomorrow morning"에서 내일 아침 외출 시 따뜻하게 입으라고 조언하고 있음을 알 수 있습니다.`,
      },
    ],
  },

  talk5: {
    title: "Public Announcement",
    type: "broadcast",
    versions: {
      basic: {
        script: `Attention, residents of Westwood. This is <mark>a public announcement from the city government</mark>.
        <mark>Starting next Monday</mark>, <mark>all public libraries in the city will operate under new hours</mark>. Libraries will now open at 9 a.m. instead of 8 a.m., and they will close an hour earlier on weekends. Residents are encouraged to check the city's website for details about each location's specific schedule.
        In other news, the local waste management department has announced that <mark>garbage collection will be delayed by one day next week due to a national holiday</mark>. Residents should place their bins outside a day later than usual.
        Finally, a public safety drill is scheduled for this Wednesday at City Hall. Local emergency responders will conduct fire and earthquake safety exercises, and visitors may notice some temporary roadblocks around the area.
        That concludes today's public announcement. Thank you for your attention.`,
        translation: `웨스트우드 주민 여러분, 주목해 주시기 바랍니다. 시 정부의 공공 공지사항입니다.
        다음 주 월요일부터 시내 모든 공공 도서관의 운영 시간이 변경됩니다. 도서관은 오전 8시가 아닌 오전 9시에 개관하며, 주말에는 한 시간 일찍 폐관합니다. 주민들은 각 도서관의 구체적인 일정을 시 웹사이트에서 확인하시기 바랍니다.
        다음으로, 지역 폐기물 관리부에서 공휴일로 인해 다음 주 쓰레기 수거가 하루 지연될 것이라고 발표했습니다. 주민들은 평소보다 하루 늦게 쓰레기통을 내놓으시기 바랍니다.
        마지막으로, 이번 수요일 시청에서 공공 안전 훈련이 예정되어 있습니다. 지역 응급 대응팀이 화재 및 지진 안전 훈련을 실시할 예정이며, 방문객들은 해당 지역 주변에 임시 도로 통제가 있을 수 있음을 참고하시기 바랍니다.
        이상으로 오늘의 공공 공지사항을 마칩니다. 경청해 주셔서 감사합니다.`,
        audioUrl: {
          us: "audios/part4/broadcast/us/us5.mp3",
          uk: "audios/part4/broadcast/uk/uk5.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main purpose of the announcement?",
        questionKr: "이 공지의 주요 목적은 무엇입니까?",
        options: {
          A: "To make a <mark>public announcement</mark> to residents",
          B: "To inform people about a new <mark>city law</mark>",
          C: "To advertise a <mark>community event</mark>",
          D: "To request volunteers for a <mark>safety drill</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 주민들에게 공공 공지사항을 전달하기 위해
B: 사람들에게 새로운 시 법령을 알리기 위해
C: 지역사회 행사를 광고하기 위해
D: 안전 훈련을 위한 자원봉사자를 요청하기 위해

정답 A: 스크립트의 "This is a public announcement from the city government"에서 이 방송이 시 정부의 공공 공지사항임을 명확히 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What change will happen next <mark>Monday</mark>?",
        questionKr: "다음 주 월요일에 어떤 변화가 있을 예정입니까?",
        options: {
          A: "<mark>Public libraries</mark> will change their operating hours",
          B: "A <mark>new</mark> <mark>traffic rule</mark> will take effect",
          C: "A <mark>government office</mark> will be relocated",
          D: "A <mark>public park</mark> will be temporarily closed",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 공공 도서관들이 운영 시간을 변경할 것이다
B: 새로운 교통 규칙이 시행될 것이다
C: 정부 사무실이 이전할 것이다
D: 공원이 일시적으로 폐쇄될 것이다

정답 A: 스크립트의 "Starting next Monday, all public libraries in the city will operate under new hours"에서 다음 주 월요일부터 도서관 운영 시간이 변경될 것임을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "What does the speaker say about <mark>garbage collection</mark>?",
        questionKr: "연사는 쓰레기 수거에 대해 무엇이라고 말합니까?",
        options: {
          A: "It will be handled by a <mark>new</mark> <mark>company</mark>",
          B: "It will be delayed due to a <mark>holiday</mark>",
          C: "It will happen <mark>twice</mark> <mark>next week</mark>",
          D: "It will follow the <mark>regular</mark> schedule",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 새로운 회사가 담당하게 될 것이다
B: 공휴일로 인해 지연될 것이다
C: 다음 주에 두 번 있을 것이다
D: 정규 일정을 따를 것이다

정답 B: 스크립트의 "garbage collection will be delayed by one day next week due to a national holiday"에서 공휴일로 인해 쓰레기 수거가 하루 지연될 것임을 알 수 있습니다.`,
      },
    ],
  },

  talk6: {
    title: "Metro Traffic Update",
    type: "broadcast",
    versions: {
      basic: {
        script: `Good morning, commuters. This is Metro Traffic Update, <mark>bringing you the latest road conditions</mark>.
        <mark>Traffic is moving slowly on Highway 27 due to an accident near exit 14</mark>. The left two lanes remain blocked, and emergency crews are currently on the scene. Drivers should expect significant delays in both directions and consider using Main Street as an alternate route.
        Meanwhile, construction work continues on the downtown bridge, causing heavy congestion during rush hour. Authorities advise avoiding the area if possible, as only one lane is open in each direction.
        For those taking public transportation, subway line 3 is experiencing delays due to a mechanical issue. Trains are running 10 to 15 minutes behind schedule. <mark>Passengers should check the transit authority's website for live updates</mark>.
        That's all for now. Stay tuned for more traffic updates throughout the day.`,
        translation: `안녕하세요 출근하시는 여러분. 최신 도로 상황을 전해드리는 메트로 교통 업데이트입니다.
        27번 고속도로 14번 출구 근처의 사고로 인해 교통이 서행 중입니다. 왼쪽 두 차선이 여전히 막혀있으며, 현재 응급 구조대가 현장에 있습니다. 운전자들은 양방향 모두 상당한 지연을 예상해야 하며, 메인 스트리트를 우회로로 고려하시기 바랍니다.
        한편, 도심 다리의 공사가 계속되어 출근 시간대에 심한 정체가 발생하고 있습니다. 각 방향 한 차선만 개방되어 있어 당국은 가능하면 해당 지역을 피하라고 권고하고 있습니다.
        대중교통을 이용하시는 분들을 위해 알려드리면, 지하철 3호선이 기계적 문제로 인해 지연되고 있습니다. 열차가 10-15분 지연 운행 중입니다. 승객들은 교통당국 웹사이트에서 실시간 업데이트를 확인하시기 바랍니다.
        지금까지입니다. 하루 종일 계속되는 교통 업데이트에 귀 기울여 주시기 바랍니다.`,
        audioUrl: {
          us: "audios/part4/broadcast/us/us6.mp3",
          uk: "audios/part4/broadcast/uk/uk6.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main purpose of the announcement?",
        questionKr: "이 공지의 주요 목적은 무엇입니까?",
        options: {
          A: "To provide information about <mark>current traffic conditions</mark>",
          B: "To notify drivers about road closures <mark>next week</mark>",
          C: "To announce <mark>new</mark> public transportation <mark>routes</mark>",
          D: "To explain upcoming <mark>construction projects</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 현재 교통 상황에 대한 정보를 제공하기 위해
B: 다음 주 도로 폐쇄에 대해 운전자들에게 알리기 위해
C: 새로운 대중교통 노선을 발표하기 위해
D: 예정된 공사 프로젝트를 설명하기 위해

정답 A: 스크립트의 "This is Metro Traffic Update, bringing you the latest road conditions"에서 현재 교통 상황에 대한 정보를 제공하는 것이 주요 목적임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What does the speaker say about <mark>Highway 27</mark>?",
        questionKr: "연사는 27번 고속도로에 대해 무엇이라고 말합니까?",
        options: {
          A: "It will be closed for <mark>maintenance</mark>",
          B: "An <mark>accident</mark> is causing traffic <mark>delays</mark>",
          C: "A <mark>new</mark> <mark>exit</mark> is being built",
          D: "<mark>Speed limits</mark> have been reduced",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 유지보수를 위해 폐쇄될 것이다
B: 사고로 인해 교통이 지연되고 있다
C: 새로운 출구가 건설 중이다
D: 속도 제한이 감소되었다

정답 B: 스크립트의 "Traffic is moving slowly on Highway 27 due to an accident near exit 14"에서 27번 고속도로에서 사고로 인해 교통이 지연되고 있음을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "What does the speaker suggest <mark>subway passengers</mark> do?",
        questionKr: "연사는 지하철 승객들에게 무엇을 제안합니까?",
        options: {
          A: "Check the <mark>transit authority's website</mark> for updates",
          B: "Expect delays due to a <mark>mechanical issue</mark>",
          C: "Take the <mark>bus</mark> instead of the <mark>subway</mark>",
          D: "Use a different <mark>subway</mark> <mark>line</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 교통당국 웹사이트에서 업데이트를 확인하라
B: 기계적 문제로 인한 지연을 예상하라
C: 지하철 대신 버스를 이용하라
D: 다른 지하철 노선을 이용하라

정답 A: 스크립트의 "Passengers should check the transit authority's website for live updates"에서 승객들에게 교통당국 웹사이트에서 업데이트를 확인하라고 제안하고 있음을 알 수 있습니다.`,
      },
    ],
  },

  talk7: {
    title: "City Business Report",
    type: "broadcast",
    versions: {
      basic: {
        script: `Good evening, listeners. This is <mark>City Business Report, bringing you the latest updates on local commerce</mark>.
        A new shopping mall, <mark>Riverside Plaza</mark>, is set to open downtown next month. <mark>The complex will feature over 50 retail stores</mark>, a food court, and a cinema. Developers expect the mall to create more than 500 jobs in the area, benefiting the local economy.
        In addition, the city government has approved a <mark>new business incentive program</mark>. Under this initiative, <mark>small business</mark> owners will receive tax benefits and financial assistance <mark>to help grow their companies</mark>. Local officials hope this will encourage more entrepreneurs to open stores in the downtown area.
        That's all for today's business news. Stay tuned for more updates.`,
        translation: `안녕하세요 청취자 여러분. 지역 상업 소식을 전해드리는 시티 비즈니스 리포트입니다.
        새로운 쇼핑몰인 리버사이드 플라자가 다음 달 도심에 문을 열 예정입니다. 이 복합 시설에는 50개 이상의 소매점, 푸드코트, 영화관이 들어설 예정입니다. 개발사는 이 쇼핑몰이 이 지역에 500개 이상의 일자리를 창출하여 지역 경제에 도움이 될 것으로 기대하고 있습니다.
        또한, 시 정부는 새로운 사업 인센티브 프로그램을 승인했습니다. 이 계획에 따라 소규모 사업자들은 사업 성장을 돕기 위한 세금 혜택과 재정 지원을 받게 됩니다. 지역 관계자들은 이를 통해 더 많은 사업가들이 도심 지역에 매장을 열도록 장려하기를 희망하고 있습니다.
        지금까지 오늘의 비즈니스 뉴스였습니다. 계속해서 청취해 주시기 바랍니다.`,
        audioUrl: {
          us: "audios/part4/broadcast/us/us7.mp3",
          uk: "audios/part4/broadcast/uk/uk7.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main topic of the broadcast?",
        questionKr: "이 방송의 주요 주제는 무엇입니까?",
        options: {
          A: "The expansion of a local <mark>supermarket</mark>",
          B: "<mark>Local</mark> <mark>business</mark> <mark>news</mark>",
          C: "A new <mark>employment law</mark> affecting small businesses",
          D: "The rise of <mark>online shopping</mark> trends",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 지역 슈퍼마켓의 확장
B: 지역 비즈니스 뉴스
C: 소규모 사업체에 영향을 미치는 새로운 고용법
D: 온라인 쇼핑 트렌드의 증가

정답 B: 스크립트의 "This is City Business Report, bringing you the latest updates on local commerce"에서 이 방송이 지역 비즈니스 뉴스를 제공하는 것이 주요 주제임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          "What does the speaker say about <mark>Riverside Plaza</mark>?",
        questionKr: "연사는 리버사이드 플라자에 대해 무엇이라고 말합니까?",
        options: {
          A: "It will include <mark>over 50 retail stores</mark>",
          B: "It will open by the <mark>end of this year</mark>",
          C: "It will replace an <mark>old shopping center</mark>",
          D: "It will be built in a <mark>residential neighborhood</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 50개 이상의 소매점을 포함할 것이다
B: 올해 말까지 개장할 것이다
C: 오래된 쇼핑센터를 대체할 것이다
D: 주거 지역에 건설될 것이다

정답 A: 스크립트의 "The complex will feature over 50 retail stores, a food court, and a cinema"에서 리버사이드 플라자가 50개 이상의 소매점을 포함할 것임을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What is the purpose of the <mark>new city program</mark>?",
        questionKr: "새로운 시 프로그램의 목적은 무엇입니까?",
        options: {
          A: "To help <mark>small business</mark> growth",
          B: "To increase government <mark>tax revenue</mark>",
          C: "To support <mark>large corporations</mark>",
          D: "To improve <mark>public transportation</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 소규모 사업 성장을 돕기 위해
B: 정부의 세수를 증가시키기 위해
C: 대기업을 지원하기 위해
D: 대중교통을 개선하기 위해

정답 A: 스크립트의 "Under this initiative, small business owners will receive tax benefits and financial assistance to help grow their companies"에서 이 프로그램이 소규모 사업 성장을 돕기 위한 것임을 알 수 있습니다.`,
      },
    ],
  },

  talk8: {
    title: "Local News Update",
    type: "broadcast",
    versions: {
      basic: {
        script: `Good morning, this is Sarah Kim with your local news update.
        <mark>The city council has just approved a new traffic plan to reduce congestion downtown</mark>. <mark>Starting next Monday</mark>, some streets will become one-way, and parking will be restricted in high-traffic areas. Additionally, <mark>public transportation services will be expanded, with more buses running during rush hours</mark>. City officials say the goal is to improve traffic flow and make commuting easier.
        For more details, visit the city's official website.`,
        translation: `안녕하세요, 사라 김입니다. 지역 뉴스를 전해드리겠습니다.
        시의회가 도심의 교통 혼잡을 줄이기 위한 새로운 교통 계획을 승인했습니다. 다음 주 월요일부터 일부 도로가 일방통행으로 변경되며, 교통량이 많은 지역의 주차가 제한됩니다. 또한, 대중교통 서비스가 확대되어 출퇴근 시간대에 더 많은 버스가 운행될 예정입니다. 시 관계자들은 이를 통해 교통 흐름을 개선하고 출퇴근을 더 쉽게 만드는 것이 목표라고 말했습니다.
        자세한 내용은 시 공식 웹사이트를 방문해 주시기 바랍니다.`,
        audioUrl: {
          us: "audios/part4/broadcast/us/us8.mp3",
          uk: "audios/part4/broadcast/uk/uk8.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main topic of the announcement?",
        questionKr: "이 공지의 주요 주제는 무엇입니까?",
        options: {
          A: "A new <mark>parking regulation</mark>",
          B: "A change in <mark>public transportation fares</mark>",
          C: "A <mark>traffic improvement plan</mark>",
          D: "A <mark>road construction</mark> project",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 새로운 주차 규정
B: 대중교통 요금 변경
C: 교통 개선 계획
D: 도로 공사 프로젝트

정답 C: 스크립트의 "The city council has just approved a new traffic plan to reduce congestion downtown"에서 이 공지의 주요 주제가 교통 개선 계획임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "When will the changes take effect?",
        questionKr: "이 변경사항들은 언제부터 시행됩니까?",
        options: {
          A: "This <mark>weekend</mark>",
          B: "<mark>Next Monday</mark>",
          C: "At the beginning of <mark>next month</mark>",
          D: "In <mark>two weeks</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 이번 주말
B: 다음 주 월요일
C: 다음 달 초
D: 2주 후

정답 B: 스크립트의 "Starting next Monday, some streets will become one-way"에서 변경사항이 다음 주 월요일부터 시행됨을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "According to the announcement, how will <mark>public transportation</mark> change?",
        questionKr: "공지에 따르면, 대중교통은 어떻게 변경됩니까?",
        options: {
          A: "A <mark>subway line</mark> will be added",
          B: "<mark>More buses</mark> will run during <mark>rush hours</mark>",
          C: "New <mark>bus routes</mark> will be created in suburban areas",
          D: "Free <mark>shuttle services</mark> will be provided",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 지하철 노선이 추가될 것이다
B: 출퇴근 시간대에 더 많은 버스가 운행될 것이다
C: 교외 지역에 새로운 버스 노선이 생길 것이다
D: 무료 셔틀 서비스가 제공될 것이다

정답 B: 스크립트의 "public transportation services will be expanded, with more buses running during rush hours"에서 출퇴근 시간대에 더 많은 버스가 운행될 것임을 알 수 있습니다.`,
      },
    ],
  },

  talk9: {
    title: "Sports Update",
    type: "broadcast",
    versions: {
      basic: {
        script: `Good evening, sports fans! I'm Mark Evans with your latest sports update.
        <mark>In baseball</mark>, the Chicago Tigers secured a 5-3 victory against the New York Hawks last night, thanks to an <mark>outstanding performance by pitcher Jake Reynolds, who struck out ten batters</mark>. Meanwhile, in basketball, the Springfield Warriors dominated their match, defeating the Denver Falcons by a score of 98-79.
        Looking ahead, the <mark>national tennis tournament</mark> will kick off this Friday at Grandview Stadium. Fans should note that <mark>due to expected heavy rain, some matches may be rescheduled</mark>. Stay tuned for further updates!`,
        translation: `안녕하세요 스포츠 팬 여러분! 마크 에반스가 최신 스포츠 소식을 전해드립니다.
        야구 소식입니다. 시카고 타이거스가 투수 제이크 레이놀즈의 뛰어난 활약으로 어제 밤 뉴욕 호크스를 5-3으로 이겼습니다. 레이놀즈는 10명의 타자를 삼진으로 잡아냈습니다. 한편 농구에서는 스프링필드 워리어스가 경기를 지배하며 덴버 팔콘스를 98-79로 이겼습니다.
        다가오는 소식으로, 전국 테니스 대회가 이번 금요일 그랜드뷰 스타디움에서 시작됩니다. 팬 여러분들은 많은 비가 예상되어 일부 경기가 일정이 변경될 수 있다는 점 참고해 주시기 바랍니다. 계속해서 업데이트 소식 전해드리겠습니다!`,
        audioUrl: {
          us: "audios/part4/broadcast/us/us9.mp3",
          uk: "audios/part4/broadcast/uk/uk9.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main purpose of the announcement?",
        questionKr: "이 공지의 주요 목적은 무엇입니까?",
        options: {
          A: "To <mark>invite</mark> listeners to a <mark>sports event</mark>",
          B: "To provide updates on team <mark>rankings</mark>",
          C: "To <mark>report</mark> the latest <mark>sports news</mark>",
          D: "To interview a famous <mark>athlete</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 청취자들을 스포츠 행사에 초대하기 위해
B: 팀 순위에 대한 업데이트를 제공하기 위해
C: 최신 스포츠 소식을 전하기 위해
D: 유명 운동선수를 인터뷰하기 위해

정답 C: 스크립트의 "I'm Mark Evans with your latest sports update"와 이어지는 여러 스포츠 경기 결과 보도를 통해 이 방송의 주요 목적이 최신 스포츠 소식을 전하는 것임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          "Who performed exceptionally well in a <mark>baseball</mark> game?",
        questionKr: "누가 야구 경기에서 특별히 좋은 활약을 보였습니까?",
        options: {
          A: "A player from the <mark>New York Hawks</mark>",
          B: "A <mark>basketball</mark> team's top scorer",
          C: "<mark>Jake Reynolds</mark>",
          D: "A coach of the <mark>Chicago Tigers</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 뉴욕 호크스의 선수
B: 농구팀의 최고 득점자
C: 제이크 레이놀즈
D: 시카고 타이거스의 코치

정답 C: 스크립트의 "an outstanding performance by pitcher Jake Reynolds, who struck out ten batters"에서 제이크 레이놀즈가 야구 경기에서 특별히 좋은 활약을 보였음을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "What is expected to happen at the <mark>national tennis tournament</mark>?",
        questionKr: "전국 테니스 대회에서 어떤 일이 예상됩니까?",
        options: {
          A: "<mark>Ticket prices</mark> will increase",
          B: "The <mark>location</mark> will be changed",
          C: "Some matches may be <mark>rescheduled</mark> due to bad <mark>weather</mark>",
          D: "Additional <mark>players</mark> will be added to the tournament",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 입장권 가격이 인상될 것이다
B: 장소가 변경될 것이다
C: 나쁜 날씨로 인해 일부 경기 일정이 변경될 수 있다
D: 대회에 추가 선수들이 합류할 것이다

정답 C: 스크립트의 "due to expected heavy rain, some matches may be rescheduled"에서 비로 인해 일부 경기 일정이 변경될 수 있음을 알 수 있습니다.`,
      },
    ],
  },

  talk10: {
    title: "Weather Update",
    type: "broadcast",
    versions: {
      basic: {
        script: `Good morning, listeners! This is Kelly Parker with <mark>your daily weather update</mark>.
        Today, expect mostly sunny skies with a high of 28 degrees Celsius. However, temperatures will drop significantly overnight, reaching as low as 15 degrees. <mark>Tomorrow, a cold front will move in, bringing cloudy skies and scattered showers throughout the day</mark>. In the northern region, <mark>strong winds of up to 50 kilometers per hour are expected, so residents should take precautions when traveling</mark>. For those commuting to work, be aware that heavy morning fog might cause some traffic delays.
        Stay tuned for more updates!`,
        translation: `안녕하세요 청취자 여러분! 켈리 파커가 오늘의 날씨를 전해드립니다.
        오늘은 대체로 맑은 하늘이 예상되며 최고 기온은 섭씨 28도입니다. 하지만 밤사이 기온이 크게 떨어져 최저 15도까지 내려갈 것입니다. 내일은 한랭 전선이 이동해 오면서 하루 종일 흐린 날씨와 산발적인 소나기가 예상됩니다. 북부 지역에서는 시속 50킬로미터의 강한 바람이 예상되므로 이동 시 주의하시기 바랍니다. 출근하시는 분들은 짙은 아침 안개로 인해 교통이 지연될 수 있다는 점 참고하시기 바랍니다.
        계속해서 업데이트 소식 전해드리겠습니다!`,
        audioUrl: {
          us: "audios/part4/broadcast/us/us10.mp3",
          uk: "audios/part4/broadcast/uk/uk10.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main topic of the announcement?",
        questionKr: "이 공지의 주요 주제는 무엇입니까?",
        options: {
          A: "<mark>Traffic conditions</mark>",
          B: "A public <mark>safety warning</mark>",
          C: "A <mark>weather forecast</mark>",
          D: "A schedule for <mark>outdoor events</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 교통 상황
B: 공공 안전 경고
C: 일기 예보
D: 야외 행사 일정

정답 C: 스크립트의 "This is Kelly Parker with your daily weather update"에서 시작하여 기온, 구름 상태, 바람, 비 등 날씨 관련 정보를 전달하는 내용으로, 이 방송의 주요 주제가 일기 예보임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What is expected to happen <mark>tomorrow</mark>?",
        questionKr: "내일 어떤 일이 예상됩니까?",
        options: {
          A: "The temperature will <mark>rise</mark>",
          B: "The <mark>sky</mark> will remain <mark>clear</mark>",
          C: "<mark>Rain</mark> and <mark>cloudy weather</mark> will occur",
          D: "A <mark>heatwave</mark> will hit the area",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 기온이 상승할 것이다
B: 하늘이 맑을 것이다
C: 비가 오고 흐린 날씨가 될 것이다
D: 폭염이 이 지역을 강타할 것이다

정답 C: 스크립트의 "Tomorrow, a cold front will move in, bringing cloudy skies and scattered showers throughout the day"에서 내일 흐린 하늘과 산발적인 소나기가 올 것임을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "What advice is given to <mark>northern region</mark> residents?",
        questionKr: "북부 지역 주민들에게 어떤 조언이 주어집니까?",
        options: {
          A: "Avoid driving in the <mark>evening</mark>",
          B: "Carry an <mark>umbrella</mark> due to unexpected rain showers",
          C: "Be cautious while traveling due to <mark>strong winds</mark>",
          D: "Prepare for extremely high <mark>temperatures</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 저녁에 운전을 피하라
B: 갑작스러운 소나기에 대비해 우산을 가져가라
C: 강한 바람으로 인해 이동 시 주의하라
D: 매우 높은 기온에 대비하라

정답 C: 스크립트의 "strong winds of up to 50 kilometers per hour are expected, so residents should take precautions when traveling"에서 강한 바람 때문에 이동 시 주의하라는 조언을 하고 있음을 알 수 있습니다.`,
      },
    ],
  },

  talk11: {
    title: "Weekend Weather Update",
    type: "broadcast",
    versions: {
      basic: {
        script: `Good afternoon, everyone. This is your weekend weather update.
        <mark>A winter storm is approaching the region, bringing heavy snowfall and strong winds</mark>. <mark>Starting late tonight, snowfall is expected to reach up to 20 centimeters in some areas</mark>, and temperatures will drop to minus 5 degrees Celsius. <mark>Tomorrow, roads may be slippery, and visibility will be reduced due to blowing snow</mark>. If you plan to drive, please allow extra travel time and use caution.
        <mark>On Sunday</mark>, <mark>the storm will move out, and we'll see clear skies</mark> with a high of 3 degrees. Stay warm and stay safe!`,
        translation: `안녕하세요 여러분. 주말 날씨 예보입니다.
        겨울 폭풍이 이 지역으로 접근하고 있어 폭설과 강풍이 예상됩니다. 오늘 늦은 밤부터 일부 지역에서는 적설량이 20센티미터에 달할 것으로 예상되며, 기온은 영하 5도까지 떨어질 것입니다. 내일은 도로가 미끄러울 수 있으며, 날리는 눈으로 인해 시야가 제한될 것입니다. 운전 계획이 있으신 분들은 여유 있게 시간을 잡으시고 주의하시기 바랍니다.
        일요일에는 폭풍이 물러나고 맑은 하늘이 보일 것이며, 최고 기온은 3도가 되겠습니다. 따뜻하게 지내시고 안전하시기 바랍니다!`,
        audioUrl: {
          us: "audios/part4/broadcast/us/us11.mp3",
          uk: "audios/part4/broadcast/uk/uk11.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What type of weather is expected <mark>tonight</mark>?",
        questionKr: "오늘 밤에는 어떤 날씨가 예상됩니까?",
        options: {
          A: "A <mark>winter storm</mark> with heavy <mark>snowfall</mark>",
          B: "A <mark>heatwave</mark> with strong winds",
          C: "<mark>Thunderstorms</mark> and high humidity",
          D: "A clear and sunny <mark>evening</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 폭설을 동반한 겨울 폭풍
B: 강풍을 동반한 폭염
C: 뇌우와 높은 습도
D: 맑고 화창한 저녁

정답 A: 스크립트의 "A winter storm is approaching the region, bringing heavy snowfall and strong winds. Starting late tonight, snowfall is expected..."에서 오늘 밤에 폭설을 동반한 겨울 폭풍이 예상됨을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What problem might drivers face <mark>tomorrow</mark>?",
        questionKr: "내일 운전자들은 어떤 문제에 직면할 수 있습니까?",
        options: {
          A: "<mark>Traffic congestion</mark> due to road construction",
          B: "Reduced <mark>visibility</mark> and <mark>slippery roads</mark>",
          C: "Heavy <mark>rain</mark> causing <mark>floods</mark>",
          D: "A major <mark>bridge closure</mark> due to high winds",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 도로 공사로 인한 교통 체증
B: 시야 제한과 미끄러운 도로
C: 홍수를 유발하는 폭우
D: 강풍으로 인한 주요 다리 폐쇄

정답 B: 스크립트의 "Tomorrow, roads may be slippery, and visibility will be reduced due to blowing snow"에서 내일 도로가 미끄럽고 눈으로 인해 시야가 제한될 것임을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What will the weather be like on <mark>Sunday</mark>?",
        questionKr: "일요일 날씨는 어떨 것입니까?",
        options: {
          A: "Rainy with <mark>strong winds</mark>",
          B: "Sunny and <mark>clear</mark>",
          C: "<mark>Snowy</mark> and stormy",
          D: "Cloudy with scattered <mark>showers</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 강풍을 동반한 비
B: 맑고 화창함
C: 눈과 폭풍
D: 산발적 소나기를 동반한 흐림

정답 B: 스크립트의 "On Sunday, the storm will move out, and we'll see clear skies with a high of 3 degrees"에서 일요일에는 폭풍이 물러나고 맑은 하늘이 예상됨을 알 수 있습니다.`,
      },
    ],
  },

  talk12: {
    title: "Tropical Weather Update",
    type: "broadcast",
    versions: {
      basic: {
        script: `Good morning, listeners. This is your tropical weather update for the region.
        <mark>A strong typhoon</mark> is currently moving toward the southeastern coastline and is expected to make landfall late tonight. The storm will bring heavy rainfall and winds of up to 120 kilometers per hour. Residents in low-lying areas should prepare for possible flooding, and local authorities have advised people <mark>to stay indoors</mark>.
        Tomorrow, the typhoon will weaken as it moves inland, but strong winds and occasional heavy rain will continue throughout the day. <mark>By Wednesday</mark>, the weather will improve, <mark>with partly cloudy skies and temperatures rising to 30 degrees Celsius</mark>. Stay tuned for further updates and follow safety instructions from local officials.`,
        translation: `안녕하세요 청취자 여러분. 이 지역의 열대성 기후 업데이트입니다.
        강력한 태풍이 현재 남동부 해안을 향해 이동 중이며 오늘 밤늦게 상륙할 것으로 예상됩니다. 이 폭풍은 폭우와 시속 120킬로미터의 강풍을 동반할 것입니다. 저지대 주민들은 홍수에 대비해야 하며, 지역 당국은 실내에 머물 것을 권고했습니다.
        내일은 태풍이 내륙으로 이동하면서 약화되겠지만, 강풍과 간헐적인 폭우가 하루 종일 계속될 것입니다. 수요일에는 날씨가 호전되어 구름이 약간 끼고 기온이 섭씨 30도까지 상승할 것입니다. 계속해서 업데이트를 확인하시고 지역 당국의 안전 지침을 따라주시기 바랍니다.`,
        audioUrl: {
          us: "audios/part4/broadcast/us/us12.mp3",
          uk: "audios/part4/broadcast/uk/uk12.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main topic of the announcement?",
        questionKr: "이 공지의 주요 주제는 무엇입니까?",
        options: {
          A: "An approaching <mark>typhoon</mark>",
          B: "A change in seasonal <mark>temperatures</mark>",
          C: "A long period of <mark>drought</mark>",
          D: "A government emergency <mark>meeting</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 다가오는 태풍
B: 계절성 기온 변화
C: 장기간의 가뭄
D: 정부 긴급 회의

정답 A: 스크립트의 "A strong typhoon is currently moving toward the southeastern coastline"에서 이 공지의 주요 주제가 다가오는 태풍임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What are residents advised to do?",
        questionKr: "주민들에게 어떤 조언이 주어졌습니까?",
        options: {
          A: "Stock up on <mark>drinking</mark> <mark>water</mark>",
          B: "<mark>Evacuate</mark> to another region",
          C: "Stay <mark>indoors</mark> due to dangerous winds",
          D: "Prepare for <mark>hot weather</mark> conditions",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 식수를 비축하라
B: 다른 지역으로 대피하라
C: 위험한 바람 때문에 실내에 머물라
D: 더운 날씨에 대비하라

정답 C: 스크립트의 "local authorities have advised people to stay indoors"에서 주민들에게 실내에 머물라는 조언이 주어졌음을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What will the weather be like on <mark>Wednesday</mark>?",
        questionKr: "수요일 날씨는 어떨 것입니까?",
        options: {
          A: "Heavy <mark>rain</mark> and strong <mark>winds</mark>",
          B: "<mark>Colder</mark> than usual",
          C: "Partly <mark>cloudy</mark> with higher <mark>temperatures</mark>",
          D: "Severe <mark>thunderstorms</mark> throughout the day",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 폭우와 강풍
B: 평소보다 추움
C: 구름이 약간 끼고 기온이 높음
D: 하루 종일 심한 뇌우

정답 C: 스크립트의 "By Wednesday, the weather will improve, with partly cloudy skies and temperatures rising to 30 degrees Celsius"에서 수요일에는 구름이 약간 끼고 기온이 높아질 것임을 알 수 있습니다.`,
      },
    ],
  },

  talk13: {
    title: "Heatwave Forecast",
    type: "broadcast",
    versions: {
      basic: {
        script: `Good morning, this is your weather report for the week. A <mark>severe heatwave</mark> is affecting the region, with temperatures expected to reach as high as 40 degrees Celsius. The heat index will make it feel even hotter, so residents are advised to stay hydrated and avoid outdoor activities during peak hours.
        <mark>Tomorrow</mark>, temperatures will remain high, but some relief is expected in the evening <mark>as winds from the coast bring slightly cooler air</mark>. However, by the weekend, temperatures will rise again, and humidity levels will increase, making conditions even more uncomfortable.
        For those planning outdoor activities, remember to <mark>apply sunscreen</mark>, <mark>wear light clothing</mark>, and drink plenty of water. Stay safe in the extreme heat!`,
        translation: `안녕하세요, 이번 주 날씨 예보입니다. 심각한 폭염이 이 지역에 영향을 미치고 있으며, 기온은 섭씨 40도까지 오를 것으로 예상됩니다. 체감온도는 더 높을 것이므로, 주민들은 수분을 충분히 섭취하고 최고 기온 시간대에는 야외 활동을 피하시기 바랍니다.
        내일도 기온이 높게 유지되겠지만, 저녁에는 해안가에서 불어오는 바람이 약간의 시원한 공기를 가져와 다소 완화될 것으로 예상됩니다. 하지만 주말에는 기온이 다시 상승하고 습도가 높아져 더욱 불쾌한 날씨가 될 것입니다.
        야외 활동을 계획하시는 분들은 자외선 차단제를 바르고, 가벼운 옷을 입고, 물을 충분히 마시는 것을 잊지 마세요. 극심한 더위 속에서 안전하시기 바랍니다!`,
        audioUrl: {
          us: "audios/part4/broadcast/us/us13.mp3",
          uk: "audios/part4/broadcast/uk/uk13.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main problem mentioned in the forecast?",
        questionKr: "예보에서 언급된 주요 문제는 무엇입니까?",
        options: {
          A: "A tropical <mark>storm</mark> approaching the region",
          B: "A severe <mark>heatwave</mark> affecting the area",
          C: "Heavy <mark>rainfall</mark> causing floods",
          D: "A sudden drop in <mark>temperature</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 이 지역으로 접근하는 열대성 폭풍
B: 이 지역에 영향을 미치는 심각한 폭염
C: 홍수를 유발하는 폭우
D: 갑작스러운 기온 하락

정답 B: 스크립트의 "A severe heatwave is affecting the region, with temperatures expected to reach as high as 40 degrees Celsius"에서 심각한 폭염이 이 지역에 영향을 미치고 있음을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What change is expected <mark>tomorrow</mark>?",
        questionKr: "내일은 어떤 변화가 예상됩니까?",
        options: {
          A: "Temperatures will <mark>drop</mark> significantly",
          B: "There will be <mark>thunderstorms</mark> in the evening",
          C: "<mark>Winds</mark> will bring slightly <mark>cooler</mark> air",
          D: "The <mark>heatwave</mark> will completely <mark>end</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 기온이 크게 떨어질 것이다
B: 저녁에 뇌우가 있을 것이다
C: 바람이 약간 시원한 공기를 가져올 것이다
D: 폭염이 완전히 끝날 것이다

정답 C: 스크립트의 "Tomorrow, temperatures will remain high, but some relief is expected in the evening as winds from the coast bring slightly cooler air"에서 내일 저녁에 해안가에서 불어오는 바람이 약간 시원한 공기를 가져올 것임을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "What advice is given to people <mark>planning outdoor activities</mark>?",
        questionKr: "청취자들에게 어떤 조언이 주어졌습니까?",
        options: {
          A: "Apply <mark>sunscreen</mark> and wear <mark>light clothing</mark>",
          B: "Close <mark>windows</mark> and doors to prevent dust from entering",
          C: "Stay inside to avoid the risk of <mark>frostbite</mark>",
          D: "Wear <mark>warm clothing</mark> when going outside",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 자외선 차단제를 바르고 가벼운 옷을 입으라
B: 먼지가 들어오는 것을 막기 위해 창문과 문을 닫으라
C: 동상 위험을 피하기 위해 실내에 머물라
D: 외출할 때 따뜻한 옷을 입으라

정답 A: 스크립트의 "For those planning outdoor activities, remember to apply sunscreen, wear light clothing, and drink plenty of water"에서 자외선 차단제를 바르고 가벼운 옷을 입으라는 조언이 주어졌음을 알 수 있습니다.`,
      },
    ],
  },

  talk14: {
    title: "Traffic Report",
    type: "broadcast",
    versions: {
      basic: {
        script: `Good morning, commuters. This is Emily Carter with your latest traffic update. <mark>Due to heavy rain overnight, several roads in the downtown area are experiencing flooding, causing major delays</mark>. Highway 27 is particularly affected, with traffic moving at just 10 kilometers per hour.
        In addition, road construction on Maple Avenue has reduced traffic to a single lane, adding further congestion. <mark>Drivers heading south are advised to take Elm Street as an alternate route</mark>.
        For those using public transportation, <mark>expect delays on the Blue Line subway due to track maintenance. Train services are running 15 minutes behind schedule</mark>. Plan accordingly, and drive safely!`,
        translation: `안녕하세요 출근하시는 여러분. 에밀리 카터가 최신 교통 상황을 전해드립니다. 밤사이 내린 폭우로 인해 도심의 여러 도로가 침수되어 큰 지연이 발생하고 있습니다. 특히 27번 고속도로가 영향을 받아 시속 10킬로미터로만 이동하고 있습니다.
        또한, 메이플 애비뉴의 도로 공사로 인해 교통이 한 차선으로 줄어 정체가 더욱 심해졌습니다. 남쪽으로 향하는 운전자들은 엘름 스트리트를 우회로로 이용하시기 바랍니다.
        대중교통을 이용하시는 분들은 블루 라인 지하철이 선로 유지보수로 인해 지연되고 있습니다. 열차 서비스가 15분 지연 운행 중입니다. 이에 맞춰 계획하시고, 안전 운전하세요!`,
        audioUrl: {
          us: "audios/part4/broadcast/us/us14.mp3",
          uk: "audios/part4/broadcast/uk/uk14.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is causing the major traffic delays?",
        questionKr: "심각한 교통 지연의 원인은 무엇입니까?",
        options: {
          A: "A broken <mark>traffic signal</mark>",
          B: "Flooding from <mark>heavy rain</mark>",
          C: "A <mark>parade</mark> taking place downtown",
          D: "A <mark>vehicle breakdown</mark> on the highway",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 고장 난 신호등
B: 폭우로 인한 침수
C: 도심에서 열리는 퍼레이드
D: 고속도로의 차량 고장

정답 B: 스크립트의 "Due to heavy rain overnight, several roads in the downtown area are experiencing flooding, causing major delays"에서 폭우로 인한 침수가 심각한 교통 지연의 원인임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          "What does the speaker recommend for <mark>drivers heading south</mark>?",
        questionKr: "연사는 남쪽으로 가는 운전자들에게 무엇을 추천합니까?",
        options: {
          A: "Using an <mark>alternate route</mark>",
          B: "Avoiding <mark>public transportation</mark>",
          C: "Driving on <mark>Highway 27</mark>",
          D: "Waiting until the <mark>rain stops</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 우회로 이용하기
B: 대중교통 피하기
C: 27번 고속도로로 운전하기
D: 비가 그칠 때까지 기다리기

정답 A: 스크립트의 "Drivers heading south are advised to take Elm Street as an alternate route"에서 남쪽으로 가는 운전자들에게 우회로를 이용하라고 추천하고 있음을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "What issue is affecting <mark>subway</mark> <mark>services</mark>?",
        questionKr: "지하철 서비스에 어떤 문제가 영향을 미치고 있습니까?",
        options: {
          A: "A <mark>strike</mark> by train operators",
          B: "A <mark>signal failure</mark> at a major station",
          C: "<mark>Track</mark> <mark>maintenance</mark> causing delays",
          D: "An <mark>increase</mark> in <mark>passenger</mark> volume",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 기관사들의 파업
B: 주요 역의 신호 고장
C: 선로 유지보수로 인한 지연
D: 승객 수 증가

정답 C: 스크립트의 "expect delays on the Blue Line subway due to track maintenance. Train services are running 15 minutes behind schedule"에서 선로 유지보수가 지하철 서비스에 영향을 미치고 있음을 알 수 있습니다.`,
      },
    ],
  },

  talk15: {
    title: "Public Service Announcement: Power & Water Outage",
    type: "broadcast",
    versions: {
      basic: {
        script: `Attention residents, this is an important announcement from the city's public utilities department. <mark>Due to unexpected equipment failure at the main power station, several neighborhoods are currently experiencing power outages</mark>. Our technicians are working to restore electricity, and <mark>we expect service to be fully restored by 8 PM tonight</mark>.
        Additionally, as a precaution, water supply in affected areas has been temporarily shut off to prevent possible contamination. <mark>Residents are advised to conserve any stored water and avoid using tap water until further notice</mark>.
        For updates, please visit our official website or call our emergency hotline. We apologize for the inconvenience and appreciate your patience.`,
        translation: `주민 여러분께 알립니다. 이것은 시 공공시설부의 중요한 공지입니다. 주 발전소의 예기치 않은 장비 고장으로 인해 여러 지역에서 현재 정전이 발생하고 있습니다. 우리 기술자들이 전기 복구 작업을 하고 있으며, 오늘 저녁 8시까지 서비스가 완전히 복구될 것으로 예상됩니다.
        또한, 예방 차원에서 영향을 받는 지역의 수도 공급이 오염 가능성을 방지하기 위해 일시적으로 중단되었습니다. 주민들은 저장된 물을 절약하고 추가 공지가 있을 때까지 수돗물 사용을 피하시기 바랍니다.
        업데이트 사항은 공식 웹사이트를 방문하시거나 비상 핫라인으로 전화해 주시기 바랍니다. 불편을 끼쳐 죄송하며 여러분의 양해에 감사드립니다.`,
        audioUrl: {
          us: "audios/part4/broadcast/us/us15.mp3",
          uk: "audios/part4/broadcast/uk/uk15.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the announcement about?",
        questionKr: "이 공지는 무엇에 관한 것입니까?",
        options: {
          A: "A change in city <mark>regulations</mark>",
          B: "A new public <mark>transportation</mark> schedule",
          C: "<mark>Power outages</mark> due to equipment <mark>failure</mark>",
          D: "A road <mark>construction</mark> project",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 시 규정의 변경
B: 새로운 대중교통 일정
C: 장비 고장으로 인한 정전
D: 도로 공사 프로젝트

정답 C: 스크립트의 "Due to unexpected equipment failure at the main power station, several neighborhoods are currently experiencing power outages"에서 이 공지가 장비 고장으로 인한 정전에 관한 것임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "When is the electricity expected to be restored?",
        questionKr: "전기는 언제 복구될 것으로 예상됩니까?",
        options: {
          A: "By <mark>8 PM</mark>",
          B: "By <mark>midnight</mark>",
          C: "Early <mark>tomorrow</mark> morning",
          D: "It is still <mark>uncertain</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 저녁 8시까지
B: 자정까지
C: 내일 이른 아침
D: 아직 불확실함

정답 A: 스크립트의 "we expect service to be fully restored by 8 PM tonight"에서 전기가 오늘 저녁 8시까지 복구될 것으로 예상됨을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What does the speaker advise residents to do?",
        questionKr: "연사는 주민들에게 무엇을 하라고 조언합니까?",
        options: {
          A: "Conserve <mark>stored</mark> <mark>water</mark>",
          B: "<mark>Boil</mark> <mark>water</mark> before drinking",
          C: "Move to a temporary <mark>shelter</mark>",
          D: "Use <mark>public</mark> <mark>generators</mark> for electricity",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
A: 저장된 물을 절약하라
B: 마시기 전에 물을 끓여라
C: 임시 대피소로 이동하라
D: 전기를 위해 공공 발전기를 사용하라

정답 A: 스크립트의 "Residents are advised to conserve any stored water and avoid using tap water until further notice"에서 주민들에게 저장된 물을 절약하라고 조언하고 있음을 알 수 있습니다.`,
      },
    ],
  },

  talk16: {
    title: "Emergency Evacuation Broadcast",
    type: "broadcast",
    versions: {
      basic: {
        script: `Attention, residents. This is an emergency announcement from the city's disaster response center. <mark>A wildfire has been spreading rapidly due to strong winds, and evacuation orders have been issued</mark> for communities near Green Valley and Riverside.
        <mark>All residents in the affected areas must leave immediately and head to the designated evacuation centers at Pinewood High School and Westfield Community Hall</mark>. Please follow the instructions of local authorities and do not attempt to return home until it is declared safe.
        Emergency response teams are working to contain the fire, and <mark>updates will be provided every hour through the city's official website and radio broadcasts</mark>. Stay safe and evacuate immediately.`,
        translation: `주민 여러분께 알립니다. 이것은 시 재난대응센터의 긴급 공지입니다. 강풍으로 인해 산불이 빠르게 확산되고 있어, 그린 밸리와 리버사이드 인근 지역사회에 대피 명령이 내려졌습니다.
        영향을 받는 지역의 모든 주민들은 즉시 대피하여 지정된 대피소인 파인우드 고등학교와 웨스트필드 커뮤니티 홀로 이동해야 합니다. 지역 당국의 지시를 따라주시고 안전하다고 선언될 때까지 집으로 돌아가려 하지 마십시오.
        비상 대응팀이 화재 진압 작업을 하고 있으며, 시 공식 웹사이트와 라디오 방송을 통해 매시간 업데이트가 제공될 것입니다. 안전하게 지내시고 즉시 대피하시기 바랍니다.`,
        audioUrl: {
          us: "audios/part4/broadcast/us/us16.mp3",
          uk: "audios/part4/broadcast/uk/uk16.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the announcement about?",
        questionKr: "이 공지는 무엇에 관한 것입니까?",
        options: {
          A: "A <mark>power outage</mark> in the area",
          B: "A <mark>traffic accident</mark>",
          C: "An emergency evacuation due to a <mark>wildfire</mark>",
          D: "A planned city-wide <mark>fire drill</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 이 지역의 정전
B: 그린 밸리 근처의 교통사고
C: 산불로 인한 긴급 대피
D: 계획된 시 전체 화재 훈련

정답 C: 스크립트의 "A wildfire has been spreading rapidly due to strong winds, and evacuation orders have been issued"에서 이 공지가 산불로 인한 긴급 대피에 관한 것임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          "Where should residents <mark>in the affected areas</mark> go?",
        questionKr: "주민들은 어디로 가야 합니까?",
        options: {
          A: "Their local fire <mark>station</mark>",
          B: "The nearest police <mark>department</mark>",
          C: "<mark>Pinewood High School</mark> or <mark>Westfield Community Hall</mark>",
          D: "A <mark>hotel</mark> outside the city",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 지역 소방서
B: 가장 가까운 경찰서
C: 파인우드 고등학교 또는 웨스트필드 커뮤니티 홀
D: 시 외곽의 호텔

정답 C: 스크립트의 "All residents in the affected areas must leave immediately and head to the designated evacuation centers at Pinewood High School and Westfield Community Hall"에서 주민들이 파인우드 고등학교나 웨스트필드 커뮤니티 홀로 가야 함을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "How will <mark>updates</mark> about the situation be provided?",
        questionKr: "상황에 대한 업데이트는 어떻게 제공될 예정입니까?",
        options: {
          A: "Through <mark>door-to-door</mark> notifications",
          B: "By <mark>text messages</mark> to all residents",
          C: "Through the city's <mark>website</mark> and <mark>radio</mark> broadcasts",
          D: "During daily <mark>press conferences</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
      A: 직접 방문 통지를 통해 (각 집을 일일이 방문하여 알리는 방식)
      B: 모든 주민들에게 문자 메시지로
      C: 시 공식 웹사이트와 라디오 방송을 통해
      D: 매일 열리는 기자회견에서
      
      정답 C: 스크립트의 "updates will be provided every hour through the city's official website and radio broadcasts"에서 업데이트가 시 공식 웹사이트와 라디오 방송을 통해 제공될 것임을 알 수 있습니다.`,
      },
    ],
  },

  talk17: {
    title: "Riverside Summer Festival Announcement",
    type: "broadcast",
    versions: {
      basic: {
        script: `Good afternoon, everyone! This is an important announcement about the upcoming Riverside Summer Festival. <mark>The festival will take place this Saturday at Riverside Park and will feature live music, food vendors, and a spectacular fireworks display at 9 PM</mark>.
        The event will begin at 3 PM with a local band performance, <mark>followed by a dance competition at 5 PM</mark>. There will also be a family-friendly movie screening at 7 PM before the fireworks show.
        Admission is free, but <mark>attendees are encouraged to arrive early to secure a good spot</mark>. For more details, visit our official website or follow us on social media. We look forward to seeing you there!`,
        translation: `안녕하세요 여러분! 다가오는 리버사이드 여름 축제에 대한 중요한 공지입니다. 축제는 이번 토요일 리버사이드 공원에서 열리며, 라이브 음악, 음식 판매점, 그리고 저녁 9시에 화려한 불꽃놀이가 진행될 예정입니다.
        행사는 오후 3시에 지역 밴드 공연으로 시작하여, 오후 5시에 댄스 경연대회가 이어집니다. 불꽃놀이 쇼 전인 오후 7시에는 가족 영화 상영도 있을 예정입니다.
        입장은 무료이지만, 좋은 자리를 확보하기 위해 일찍 도착하시기를 권장합니다. 자세한 내용은 공식 웹사이트를 방문하시거나 소셜 미디어를 팔로우해 주시기 바랍니다. 여러분을 만나뵙기를 기대합니다!`,
        audioUrl: {
          us: "audios/part4/broadcast/us/us17.mp3",
          uk: "audios/part4/broadcast/uk/uk17.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the announcement mainly about?",
        questionKr: "이 공지는 주로 무엇에 관한 것입니까?",
        options: {
          A: "A <mark>road closure</mark>",
          B: "A change in <mark>festival rules</mark>",
          C: "A summer <mark>festival schedule</mark>",
          D: "A <mark>new restaurant</mark> opening",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 리버사이드의 도로 폐쇄
B: 축제 규칙의 변경
C: 여름 축제 일정
D: 새로운 레스토랑 개업

정답 C: 스크립트의 "This is an important announcement about the upcoming Riverside Summer Festival"로 시작하여 축제가 열리는 시간, 장소, 그리고 3시부터 9시까지의 행사 일정을 자세히 설명하고 있어 여름 축제 일정에 관한 것임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What will happen at 5 PM?",
        questionKr: "오후 5시에는 무엇이 열립니까?",
        options: {
          A: "A <mark>parade</mark>",
          B: "A <mark>food</mark> competition",
          C: "A <mark>dance</mark> contest",
          D: "A <mark>fireworks</mark> display",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 퍼레이드
B: 음식 경연대회
C: 댄스 경연대회
D: 불꽃놀이 쇼

정답 C: 스크립트의 "followed by a dance competition at 5 PM"에서 오후 5시에 댄스 경연대회가 열림을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What does the speaker suggest to attendees?",
        questionKr: "연사는 참가자들에게 무엇을 제안합니까?",
        options: {
          A: "Buy <mark>tickets</mark> in advance",
          B: "Bring a <mark>picnic blanket</mark>",
          C: "Arrive early to get a <mark>good spot</mark>",
          D: "Avoid bringing <mark>outside food</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
A: 미리 티켓을 구매하라
B: 피크닉 담요를 가져오라
C: 좋은 자리를 잡기 위해 일찍 도착하라
D: 외부 음식을 가져오지 말라

정답 C: 스크립트의 "attendees are encouraged to arrive early to secure a good spot"에서 좋은 자리를 확보하기 위해 일찍 도착하라고 제안하고 있음을 알 수 있습니다.`,
      },
    ],
  },

  talk18: {
    title: "Health & Wellness Radio Show Introduction",
    type: "broadcast",
    versions: {
      basic: {
        script: `Good afternoon, and welcome to Health & Wellness Today on WNTX Radio. I'm your host, Sarah Peterson. Today, we'll be speaking with Dr. Jason Lee, a leading expert in sleep science and its impact on mental health.
        <mark>Dr. Lee is well-known for his research on how sleep deprivation affects cognitive function</mark>. His studies show that even a slight reduction in sleep can significantly impact concentration and decision-making.
        <mark>Later in the program, Dr. Lee will share tips on improving sleep quality and explain why sleep is just as important as diet and exercise</mark>. But first, <mark>I'd like to play an excerpt from his keynote speech at the National Health Conference</mark>, where he discusses the long-term effects of chronic sleep loss. His insights are truly eye-opening.`,
        translation: `안녕하세요, WNTX 라디오의 건강과 웰빙 투데이에 오신 것을 환영합니다. 진행자 사라 피터슨입니다. 오늘은 수면 과학과 정신 건강에 미치는 영향에 대한 전문가인 제이슨 리 박사님과 이야기를 나눠보겠습니다.
        리 박사님은 수면 부족이 인지 기능에 미치는 영향에 대한 연구로 잘 알려져 있습니다. 그의 연구에 따르면 약간의 수면 부족도 집중력과 의사결정에 상당한 영향을 미칠 수 있다고 합니다.
        프로그램 후반부에서는 리 박사님이 수면의 질을 개선하는 팁을 공유하고 수면이 식단과 운동만큼 중요한 이유를 설명해 주실 예정입니다. 하지만 먼저, 만성 수면 부족의 장기적 영향에 대해 논의한 전국 보건 컨퍼런스에서의 기조연설 일부를 들려드리겠습니다. 그의 통찰력은 정말 눈을 뜨게 해줄 것입니다.`,
        audioUrl: {
          us: "audios/part4/broadcast/us/us18.mp3",
          uk: "audios/part4/broadcast/uk/uk18.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question:
          "According to the speaker, what is <mark>Dr. Lee</mark> known for?",
        questionKr: "연사에 따르면, 리 박사는 무엇으로 유명합니까?",
        options: {
          A: "Creating a <mark>fitness program</mark>",
          B: "Studying the effects of <mark>sleep deprivation</mark>",
          C: "Writing books about <mark>nutrition</mark>",
          D: "Developing <mark>meditation</mark> techniques",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
    A: 피트니스 프로그램 개발
    B: 수면 부족의 영향 연구
    C: 영양에 관한 책 저술
    D: 명상 기법 개발
    
    정답 B: 스크립트의 "Dr. Lee is well-known for his research on how sleep deprivation affects cognitive function"에서 리 박사가 수면 부족이 인지 기능에 미치는 영향에 대한 연구로 유명함을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What will <mark>Dr. Lee</mark> most likely discuss later?",
        questionKr: "리 박사는 나중에 무엇을 논의할 가능성이 가장 높습니까?",
        options: {
          A: "Tips for improving <mark>sleep quality</mark>",
          B: "How to manage <mark>stress at work</mark>",
          C: "The latest <mark>diet trends</mark>",
          D: "The benefits of <mark>morning workouts</mark>",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
    A: 수면의 질을 개선하는 팁
    B: 직장에서의 스트레스 관리 방법
    C: 최신 다이어트 트렌드
    D: 아침 운동의 이점
    
    정답 A: 스크립트의 "Later in the program, Dr. Lee will share tips on improving sleep quality and explain why sleep is just as important as diet and exercise"에서 리 박사가 나중에 수면의 질을 개선하는 팁을 공유할 것임을 직접적으로 언급하고 있습니다.`,
      },
      {
        id: 3,
        question: "What will the listeners probably hear next?",
        questionKr: "청취자들은 다음에 무엇을 들을 가능성이 높습니까?",
        options: {
          A: "A <mark>live interview</mark> with Dr. Lee",
          B: "A recorded <mark>speech</mark>",
          C: "A <mark>news update</mark>",
          D: "A <mark>commercial break</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
    A: 리 박사와의 생방송 인터뷰
    B: 녹음된 연설
    C: 뉴스 업데이트
    D: 광고 시간
    
    정답 B: 스크립트의 "But first, I'd like to play an excerpt from his keynote speech at the National Health Conference"에서 청취자들이 다음에 리 박사의 컨퍼런스 기조연설(녹음된 연설)을 들을 것임을 알 수 있습니다.`,
      },
    ],
  },

  talk19: {
    title: "Interview Segment: Electric Cars & the Future of Transportation",
    type: "broadcast",
    versions: {
      basic: {
        script: `Welcome to Tech & Mobility on WBRN Radio. I'm your host, Michael Dawson, and today, we have a <mark>fascinating discussion</mark> lined up for you.
        Joining me in just a few moments is Dr. Sophia Reynolds, an expert in electric vehicle technology. Dr. Reynolds has spent over 15 years researching battery efficiency and how next-generation electric cars can revolutionize transportation.
        She will explain why <mark>advancements in battery technology</mark> are making <mark>electric cars more affordable and practical</mark> for everyday drivers. We'll also discuss how governments around the world are encouraging people to switch from gasoline to electric vehicles.
        Stay with us as we begin our conversation with Dr. Reynolds <mark>right after this short break</mark>.`,
        translation: `WBRN 라디오의 테크 & 모빌리티에 오신 것을 환영합니다. 진행자 마이클 도슨입니다. 오늘은 흥미로운 토론을 준비했습니다.
        잠시 후 전기 자동차 기술 전문가인 소피아 레이놀즈 박사님이 함께하실 예정입니다. 레이놀즈 박사님은 15년 이상 배터리 효율성과 차세대 전기차가 어떻게 교통수단의 혁명을 일으킬 수 있는지 연구해 오셨습니다.
        박사님은 배터리 기술의 발전이 어떻게 전기차를 더 저렴하고 실용적으로 만들고 있는지 설명해 주실 것입니다. 또한 전 세계 정부들이 어떻게 사람들이 가솔린차에서 전기차로 전환하도록 장려하고 있는지도 논의할 예정입니다.
        잠시 광고 후 레이놀즈 박사님과의 대화를 시작하겠습니다. 채널 고정해 주세요.`,
        audioUrl: {
          us: "audios/part4/broadcast/us/us19.mp3",
          uk: "audios/part4/broadcast/uk/uk19.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the broadcast mainly about?",
        questionKr: "이 방송은 주로 무엇에 관한 것입니까?",
        options: {
          A: "An introduction to an upcoming <mark>radio discussion</mark>",
          B: "A <mark>live debate</mark> between industry experts",
          C: "A company's latest <mark>product announcement</mark>",
          D: "<mark>Traffic updates</mark> for major highways",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
        A: 예정된 라디오 토론 소개
        B: 업계 전문가들 간의 생방송 토론
        C: 한 회사의 최신 제품 발표
        D: 주요 고속도로 교통 업데이트
        
        정답 A: 스크립트에서 "we have a fascinating discussion lined up for you"라고 말하며 곧 있을 라디오 토론을 소개하고 있습니다.`,
      },
      {
        id: 2,
        question: "What will <mark>Dr. Reynolds</mark> most likely talk about?",
        questionKr:
          "레이놀즈 박사는 무엇에 대해 이야기할 가능성이 가장 높습니까?",
        options: {
          A: "The impact of <mark>air pollution</mark> on public health",
          B: "The dangers of <mark>self-driving</mark> technology",
          C: "How <mark>battery technology</mark> makes <mark>electric cars</mark> more affordable",
          D: "The history of <mark>automobile manufacturing</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
      A: 대기 오염이 공중 보건에 미치는 영향
      B: 자율주행 기술의 위험성
      C: 배터리 기술이 어떻게 전기차를 더 저렴하게 만드는지
      D: 자동차 제조의 역사
      
      정답 C: 스크립트에서 "She will explain why advancements in battery technology are making electric cars more affordable and practical for everyday drivers"라고 명시적으로 언급하여, Dr. Reynolds가 설명할 주제가 배터리 기술이 전기차를 더 저렴하게 만드는 방법임을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What will happen next in the broadcast?",
        questionKr: "방송에서 다음에 무엇이 일어날 것입니까?",
        options: {
          A: "The host will take <mark>calls from listeners</mark>",
          B: "A <mark>commercial break</mark> will be played",
          C: "The <mark>interview</mark> with Dr. Reynolds will begin",
          D: "A news update about <mark>fuel prices</mark> will be given",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
      A: 진행자가 청취자들의 전화를 받을 것이다
      B: 광고 시간이 방송될 것이다
      C: 레이놀즈 박사와의 인터뷰가 시작될 것이다
      D: 연료 가격에 대한 뉴스 업데이트가 제공될 것이다
      
      정답 B: 스크립트의 "Stay with us as we begin our conversation with Dr. Reynolds right after this short break"에서 다음에 짧은 쉬는 시간이 있을 것임을 알 수 있습니다. 라디오 방송에서 "short break"라는 표현은 일반적으로 광고 시간을 의미하는 표준 용어입니다.`,
      },
    ],
  },

  talk20: {
    title: "Radio Segment: Sustainable Living with Emily Harris",
    type: "broadcast",
    versions: {
      basic: {
        script: `Welcome to Green Solutions on WXRP Radio. I'm your host, Daniel Miller, and today, we're diving into an important discussion about how individuals can <mark>reduce waste and live more sustainably</mark>.
        Joining me shortly is Emily Harris, <mark>an environmental researcher specializing in recycling and waste management strategies</mark>. Emily has spent years studying how cities can improve their recycling programs and reduce landfill waste.
        She will be sharing practical tips on how households can recycle more efficiently and which materials are often improperly discarded. We'll also discuss some of the biggest misconceptions people have about recycling.
        Before we bring her in, let's start by looking at some <mark>recent statistics on waste reduction efforts worldwide</mark>.`,
        translation: `WXRP 라디오의 그린 솔루션에 오신 것을 환영합니다. 진행자 다니엘 밀러입니다. 오늘은 개인이 어떻게 쓰레기를 줄이고 더 지속 가능한 삶을 살 수 있는지에 대한 중요한 논의를 시작하겠습니다.
        잠시 후 재활용과 폐기물 관리 전략을 전문으로 하는 환경 연구원 에밀리 해리스가 함께할 예정입니다. 에밀리는 도시들이 어떻게 재활용 프로그램을 개선하고 매립 폐기물을 줄일 수 있는지 연구해 왔습니다.
        그녀는 가정에서 어떻게 더 효율적으로 재활용할 수 있는지, 어떤 재료들이 자주 부적절하게 버려지는지에 대한 실용적인 팁을 공유할 예정입니다. 또한 사람들이 재활용에 대해 가지고 있는 가장 큰 오해들에 대해서도 논의할 것입니다.
        그녀를 모시기 전에, 먼저 전 세계의 폐기물 감소 노력에 대한 최근 통계를 살펴보도록 하겠습니다.`,
        audioUrl: {
          us: "audios/part4/broadcast/us/us20.mp3",
          uk: "audios/part4/broadcast/uk/uk20.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main topic of the broadcast?",
        questionKr: "이 방송의 주요 주제는 무엇입니까?",
        options: {
          A: "The economic benefits of <mark>sustainable energy</mark>",
          B: "Sustainable living and <mark>waste reduction</mark>",
          C: "A company's new biodegradable <mark>packaging</mark>",
          D: "The impact of climate change <mark>on agriculture</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 지속 가능한 에너지의 경제적 이점
  B: 지속 가능한 생활과 폐기물 감소
  C: 한 회사의 새로운 생분해성 포장재
  D: 기후 변화가 농업에 미치는 영향
  
  정답 B: 스크립트의 "today, we're diving into an important discussion about how individuals can reduce waste and live more sustainably"에서 방송의 주제가 지속 가능한 생활과 폐기물 감소임을 명확히 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What does the speaker say about <mark>Emily Harris</mark>?",
        questionKr: "연사는 에밀리 해리스에 대해 무엇이라고 말합니까?",
        options: {
          A: "She recently <mark>wrote a book</mark> on pollution",
          B: "She specializes in <mark>waste management</mark> research",
          C: "She works as a <mark>government</mark> environmental officer",
          D: "She will be discussing <mark>solar energy</mark> solutions",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 그녀는 최근 오염에 관한 책을 썼다
  B: 그녀는 폐기물 관리 연구를 전문으로 한다
  C: 그녀는 정부 환경 담당관으로 일한다
  D: 그녀는 태양 에너지 해결책에 대해 논의할 것이다
  
  정답 B: 스크립트의 "an environmental researcher specializing in recycling and waste management strategies" 및 "Emily has spent years studying how cities can improve their recycling programs and reduce landfill waste"에서 에밀리가 폐기물 관리 연구를 전문으로 함을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What will listeners probably hear next?",
        questionKr: "청취자들은 다음에 무엇을 들을 가능성이 높습니까?",
        options: {
          A: "A <mark>recorded interview</mark> with a scientist",
          B: "A report on <mark>climate change</mark> policies",
          C: "Recent statistics <mark>on waste reduction</mark>",
          D: "A <mark>phone-in</mark> segment with audience questions",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 과학자와의 녹음된 인터뷰
  B: 기후 변화 정책에 대한 보고서
  C: 폐기물 감소에 대한 최근 통계
  D: 청취자 질문을 받는 전화 연결 코너
  
  정답 C: 스크립트의 마지막 문장 "Before we bring her in, let's start by looking at some recent statistics on waste reduction efforts worldwide"에서 다음에 폐기물 감소에 관한 최근 통계를 다룰 것임을 명확히 알 수 있습니다.`,
      },
    ],
  },

  talk21: {
    title: "News Report: New Bike Lane Opens in Downtown",
    type: "broadcast",
    versions: {
      basic: {
        script: `Welcome to Metro News Update. <mark>The city of Brookfield has just opened a new bicycle path that runs through downtown</mark>, making it easier and safer for cyclists to commute.
        Since the opening last weekend, hundreds of residents have already taken advantage of the path, and <mark>many have shared positive feedback about the improved traffic flow and reduced congestion</mark>.
        However, city officials remind cyclists that helmets are required at all times, and <mark>anyone planning to ride after sunset must have proper lights on their bikes</mark>. The new bike lane is expected to encourage more people to choose eco-friendly transportation options.`,
        translation: `메트로 뉴스 업데이트입니다. 브룩필드시가 시내를 관통하는 새로운 자전거 도로를 개통했으며, 이를 통해 자전거 통근자들이 더 쉽고 안전하게 이동할 수 있게 되었습니다.
        지난 주말 개통 이후 수백 명의 주민들이 이미 이 도로를 이용했으며, 많은 사람들이 개선된 교통 흐름과 감소된 혼잡에 대해 긍정적인 피드백을 공유했습니다.
        하지만 시 관계자들은 자전거 이용자들에게 항상 헬멧을 착용해야 하며, 일몰 후 주행을 계획하는 사람은 반드시 자전거에 적절한 조명을 설치해야 한다고 상기시켰습니다. 새로운 자전거 도로는 더 많은 사람들이 친환경 교통수단을 선택하도록 장려할 것으로 기대됩니다.`,
        audioUrl: {
          us: "audios/part4/broadcast/us/us21.mp3",
          uk: "audios/part4/broadcast/uk/uk21.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the news report mainly about?",
        questionKr: "이 뉴스 보도는 주로 무엇에 관한 것입니까?",
        options: {
          A: "A <mark>campaign</mark> to promote <mark>bicycle use</mark>",
          B: "The opening of a <mark>new bicycle path</mark>",
          C: "A <mark>cycling competition</mark> in the city",
          D: "A <mark>safety program</mark> for pedestrians",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
    A: 자전거 이용을 장려하는 캠페인
    B: 새로운 자전거 도로의 개통
    C: 도시에서 열리는 자전거 대회
    D: 보행자를 위한 안전 프로그램
    
    정답 B: 스크립트의 첫 문장 "The city of Brookfield has just opened a new bicycle path that runs through downtown"에서 뉴스가 새로운 자전거 도로의 개통에 관한 것임을 명확히 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          "How did residents <mark>respond</mark> to the new bicycle path?",
        questionKr: "주민들은 새 자전거 도로에 어떻게 반응했습니까?",
        options: {
          A: "Complained about the <mark>increased traffic</mark>",
          B: "Requested more <mark>public transportation</mark> options",
          C: "Shared <mark>positive feedback</mark> about the new path",
          D: "Organized a community <mark>cleanup event</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
    A: 증가된 교통량에 대해 불평했다
    B: 더 많은 대중교통 옵션을 요청했다
    C: 새로운 도로에 대해 긍정적인 피드백을 공유했다
    D: 지역사회 청소 행사를 조직했다
    
    정답 C: 스크립트의 "many have shared positive feedback about the improved traffic flow and reduced congestion"에서 많은 주민들이 새 자전거 도로에 대해 긍정적인 피드백을 공유했음을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What is required for cyclists riding <mark>at night</mark>?",
        questionKr: "야간에 자전거를 타는 사람들에게 무엇이 필요합니까?",
        options: {
          A: "A reflective <mark>jacket</mark>",
          B: "A city-issued <mark>permit</mark>",
          C: "Proper <mark>lights</mark> on their bicycles",
          D: "A registration with the <mark>city office</mark>",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
    A: 반사 재킷
    B: 시에서 발급한 허가증
    C: 자전거에 적절한 조명
    D: 시청에 등록
    
    정답 C: 스크립트의 "anyone planning to ride after sunset must have proper lights on their bikes"에서 야간에 자전거를 타는 사람들에게는 자전거에 적절한 조명이 필요하다고 명시되어 있습니다.`,
      },
    ],
  },

  talk22: {
    title: "News Report: Public Transit Expansion",
    type: "broadcast",
    versions: {
      basic: {
        script: `Welcome to Metro City News. This morning, <mark>city officials announced plans to expand the subway system to serve more neighborhoods in the eastern district</mark>. The expansion is part of a larger effort to reduce traffic congestion and provide more public transportation options.
        <mark>While many residents welcome the new subway lines, others have expressed concerns about the construction timeline and possible disruptions to local businesses</mark>. Officials say that work is expected to begin early next year and will take approximately three years to complete.
        To address public concerns and provide more details about the project, <mark>the city will be hosting community meetings every Thursday evening at the town hall</mark>. Residents are encouraged to attend and share their feedback.`,
        translation: `메트로 시티 뉴스입니다. 오늘 아침, 시 관계자들이 동부 지역의 더 많은 동네에 서비스를 제공하기 위해 지하철 시스템을 확장하는 계획을 발표했습니다. 이 확장은 교통 혼잡을 줄이고 더 많은 대중교통 옵션을 제공하기 위한 더 큰 노력의 일환입니다.
        많은 주민들이 새로운 지하철 노선을 환영하는 한편, 일부는 공사 일정과 지역 사업체들에 미칠 수 있는 영향에 대해 우려를 표명했습니다. 관계자들은 공사가 내년 초에 시작되어 약 3년이 소요될 것이라고 말했습니다.
        공공의 우려를 해소하고 프로젝트에 대한 더 자세한 정보를 제공하기 위해, 시는 매주 목요일 저녁 시청에서 주민 회의를 개최할 예정입니다. 주민들의 참석과 피드백 공유를 권장합니다.`,
        audioUrl: {
          us: "audios/part4/broadcast/us/us22.mp3",
          uk: "audios/part4/broadcast/uk/uk22.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the news report mainly about?",
        questionKr: "이 뉴스 보도는 주로 무엇에 관한 것입니까?",
        options: {
          A: "A proposal to increase <mark>bus fares</mark>",
          B: "A plan to <mark>expand the subway</mark> system",
          C: "A new policy for <mark>electric vehicle</mark> owners",
          D: "A <mark>road maintenance</mark> project",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 버스 요금 인상 제안
B: 지하철 시스템 확장 계획
C: 전기차 소유자를 위한 새로운 정책
D: 도로 유지보수 프로젝트

정답 B: 스크립트의 첫 문장 "city officials announced plans to expand the subway system to serve more neighborhoods in the eastern district"에서 뉴스가 지하철 시스템 확장 계획에 관한 것임을 명확히 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What concern do some residents have?",
        questionKr: "일부 주민들은 어떤 우려를 가지고 있습니까?",
        options: {
          A: "The new subway lines may be <mark>too expensive</mark>",
          B: "Construction timeline and disruptions to <mark>local businesses</mark>",
          C: "The subway expansion will <mark>not serve enough people</mark>",
          D: "The subway stations will be <mark>too far from residential areas</mark>",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 새로운 지하철 노선이 너무 비쌀 수 있다
B: 공사 일정과 지역 사업체에 대한 영향
C: 지하철 확장이 충분한 사람들을 수용하지 못할 것이다
D: 지하철역이 주거 지역에서 너무 멀 것이다

정답 B: 스크립트의 "others have expressed concerns about the construction timeline and possible disruptions to local businesses"에서 일부 주민들이 공사 일정과 지역 사업체에 대한 영향을 우려하고 있음을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "How can residents learn more about the project?",
        questionKr:
          "주민들은 어떻게 이 프로젝트에 대해 더 자세히 알 수 있습니까?",
        options: {
          A: "By reading about it in a <mark>newspaper</mark>",
          B: "By attending <mark>community meetings</mark>",
          C: "By calling the <mark>transportation department</mark>",
          D: "By <mark>visiting</mark> construction sites",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 신문에서 읽어봄으로써
B: 주민 회의에 참석함으로써
C: 교통부에 전화함으로써
D: 공사 현장을 방문함으로써

정답 B: 스크립트의 "the city will be hosting community meetings every Thursday evening at the town hall"에서 주민들이 주민 회의에 참석하여 프로젝트에 대해 더 많은 정보를 얻을 수 있음을 알 수 있습니다.`,
      },
    ],
  },

  talk23: {
    title: "Literary Review: Author Daniel Harper's New Book",
    type: "broadcast",
    versions: {
      basic: {
        script: `Welcome to Literary Review on WNTX News. <mark>Today, we are featuring renowned author Daniel Harper, whose latest novel, The Silent Echo, has quickly become a bestseller</mark>.
        <mark>Harper, best known for his historical fiction novels, has won multiple literary awards</mark> and is praised for his meticulous research and engaging storytelling. His new book takes readers on a journey through 19th-century Paris, weaving a tale of mystery and political intrigue.
        <mark>Fans eager to meet the author can attend his upcoming book signing event at Riverside Bookstore this Saturday at 2 PM</mark>. More details about the event can be found on the bookstore's official website.`,
        translation: `WNTX 뉴스의 문학 리뷰에 오신 것을 환영합니다. 오늘은 최신 소설 '고요한 메아리'가 빠르게 베스트셀러가 된 유명 작가 대니얼 하퍼를 소개해드립니다.
        역사 소설로 유명한 하퍼는 여러 문학상을 수상했으며, 꼼꼼한 연구와 매력적인 스토리텔링으로 찬사를 받고 있습니다. 그의 새 책은 독자들을 19세기 파리로 안내하며, 미스터리와 정치적 음모가 얽힌 이야기를 들려줍니다.
        작가를 만나고 싶어하는 팬들은 이번 주 토요일 오후 2시에 리버사이드 서점에서 열리는 사인회에 참석할 수 있습니다. 행사에 대한 자세한 내용은 서점 공식 웹사이트에서 확인하실 수 있습니다.`,
        audioUrl: {
          us: "audios/part4/broadcast/us/us23.mp3",
          uk: "audios/part4/broadcast/uk/uk23.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the news report mainly about?",
        questionKr: "이 뉴스 보도는 주로 무엇에 관한 것입니까?",
        options: {
          A: "A famous author's <mark>new book release</mark>",
          B: "A library hosting a <mark>writing workshop</mark>",
          C: "An <mark>increase</mark> in historical fiction <mark>sales</mark>",
          D: "A <mark>new bookstore</mark> opening in the city",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
    A: 유명 작가의 새 책 출간
    B: 도서관이 주최하는 글쓰기 워크숍
    C: 역사 소설 판매량 증가
    D: 도시에 새로 문을 여는 서점
    
    정답 A: 스크립트의 "Today, we are featuring renowned author Daniel Harper, whose latest novel, The Silent Echo, has quickly become a bestseller"에서 뉴스가 유명 작가의 새 책 출간에 관한 것임을 명확히 알 수 있습니다.`,
      },

      {
        id: 2,
        question: "What is mentioned about <mark>Daniel Harper</mark>?",
        questionKr: "대니얼 하퍼에 대해 무엇이 언급되었습니까?",
        options: {
          A: "He has written a series of <mark>detective novels</mark>",
          B: "He is known for his <mark>historical fiction</mark> books",
          C: "He recently <mark>started teaching</mark> literature",
          D: "He is <mark>retiring</mark> from writing after this book",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
    A: 그는 추리 소설 시리즈를 썼다
    B: 그는 역사 소설로 유명하다
    C: 그는 최근 문학 강의를 시작했다
    D: 그는 이 책을 끝으로 작가 생활을 은퇴할 예정이다
    
    정답 B: 스크립트의 "Harper, best known for his historical fiction novels, has won multiple literary awards"에서 하퍼가 역사 소설로 유명하다는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "How can fans meet Daniel Harper?",
        questionKr: "팬들은 어떻게 대니얼 하퍼를 만날 수 있습니까?",
        options: {
          A: "By attending an <mark>online book discussion</mark>",
          B: "By visiting his <mark>official website</mark>",
          C: "By going to a <mark>book signing event</mark>",
          D: "By purchasing a <mark>limited edition</mark> copy",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
    A: 온라인 도서 토론에 참석함으로써
    B: 그의 공식 웹사이트를 방문함으로써
    C: 책 사인회에 참석함으로써
    D: 한정판 도서를 구매함으로써
    
    정답 C: 스크립트의 "Fans eager to meet the author can attend his upcoming book signing event at Riverside Bookstore this Saturday at 2 PM"에서 팬들이 책 사인회에 참석하여 하퍼를 만날 수 있음을 알 수 있습니다.`,
      },
    ],
  },
};
